import { useEffect, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { useNavigate } from 'react-router';
import { yupResolver } from '@hookform/resolvers/yup';
import {
  Avatar,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Stack,
  TextField,
  Typography,
  dialogClasses,
} from '@mui/material';
import { Grid } from '@mui/system';
import { post } from 'api';
import { get } from 'api';
import { url } from 'config/config';
import moment from 'moment';
import { enqueueSnackbar } from 'notistack';
import { useAuth } from 'providers/AuthProvider';
import * as yup from 'yup';
import IconifyIcon from 'components/base/IconifyIcon';
import PageBreadcrumb from 'components/sections/common/PageBreadcrumb';
import ProfileAvatar from './profileAvatar';

const ProfileHeader = ({
  candidate,
  setCandidate,
  profile = false,
  account = false,
  team = false,
}) => {
  const { setSessionUser } = useAuth();
  const navigate = useNavigate();
  const validationSchema = yup.object().shape({
    role: yup.string().required('Role is required'),

    modules: yup
      .array()
      .of(yup.string())
      .min(1, 'Atleast 1 Module is required')
      .required('Module is required'),

    reportingManager: yup.string().required('Reporting Manager is required'),
    jobCity: yup.string().required('Job City is required'),

    dateOfJoining: yup
      .date()
      .typeError('Invalid date')
      .max(new Date(), 'Cannot select future dates')
      .required('Date Of Joining is required'),
  });

  const {
    handleSubmit,
    control,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(validationSchema),
    mode: 'onChange',
    shouldUnregister: false,
    defaultValues: {
      role: '',
      modules: [],
      reportingManager: '',
      dateOfJoining: '',
      jobCity: '',
    },
  });
  const [open, setOpen] = useState(false);
  const [users, setUsers] = useState([]);
  const [modules, setModules] = useState([]);
  const [city, setCity] = useState([]);
  const [loading, setLoading] = useState(false);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [openConfirm, setOpenConfirm] = useState(false);

  const handleClick = () => setOpenConfirm(true);

  const handleConfirm = async () => {
    setOpenConfirm(false);
    try {
      const res = await post(`users/disqualified_candidate/${candidate._id}`);
      if (res.status == 200) {
        enqueueSnackbar(res.message || 'Candidate Status changed successfully.', {
          variant: 'success',
          autoHideDuration: 3000,
        });
        setCandidate(res.data);
      } else {
        enqueueSnackbar(res.message || 'Error while Changing Candidate Status.', {
          variant: 'error',
          autoHideDuration: 3000,
        });
      }
    } catch (error) {
      enqueueSnackbar(error.message || 'Error while Changing Candidate Status.', {
        variant: 'error',
        autoHideDuration: 3000,
      });
    } // call API here
  };

  const handleCancel = () => setOpenConfirm(false);
  // const handleClick = async () => {
  //   try {
  //     const res = await post(`users/disqualified_candidate/${candidate._id}`);
  //     if (res.status == 200) {
  //       enqueueSnackbar(res.message || 'Candidate Status changed successfully.', {
  //         variant: 'success',
  //         autoHideDuration: 3000,
  //       });
  //       setCandidate(res.data);
  //     } else {
  //       enqueueSnackbar(res.message || 'Error while Changing Candidate Status.', {
  //         variant: 'error',
  //         autoHideDuration: 3000,
  //       });
  //     }
  //   } catch (error) {
  //     enqueueSnackbar(error.message || 'Error while Changing Candidate Status.', {
  //       variant: 'error',
  //       autoHideDuration: 3000,
  //     });
  //   }
  // };

  const handleOnBoard = async () => {
    setOpen(true);
  };
  const onClose = async () => {
    reset();
    setOpen(false);
    setSubmitLoading(false);
  };

  const fetchData = async () => {
    try {
      const res = await get('users/dropdown_user');
      const res1 = await get('users/dropdown_module');
      const res2 = await post('users/dropdown_city', { id: '64510906f470354af0a761e6' });
      if (res.status == 200) {
        setUsers(res.data);
      } else {
        setUsers([]);
      }
      if (res1.status == 200) {
        setModules(res1.data);
      } else {
        setModules([]);
      }
      if (res2.status == 200) {
        setCity(res2.data);
      } else {
        setCity([]);
      }
    } catch (error) {
      enqueueSnackbar(error.message || 'Error while Fetching Data', {
        variant: 'error',
        autoHideDuration: 3000,
      });
    }
  };
  useEffect(() => {
    fetchData();
  }, []);

  const onSubmit = async (data) => {
    setSubmitLoading(true);
    const res = await post('users/create_user', { ...data, candidate: { ...candidate } });
    if (res.status == 200) {
      enqueueSnackbar(res.message || 'Candidate Onboard Successfully', {
        variant: 'success',
        autoHideDuration: 3000,
      });
      setSubmitLoading(false);
      navigate('/users');
    } else {
      enqueueSnackbar(res.message || 'Error While Onboarding Successfully', {
        variant: 'error',
        autoHideDuration: 3000,
      });
      setSubmitLoading(false);
    }
  };

  const UploadFiles = async (file) => {
    setLoading(true);
    // 1) call your upload API with FormData
    const formData = new FormData();
    formData.append('file', file);
    formData.append('id', candidate._id);
    const res = await post('users/user_profileImageChange', formData);
    if (res.status == 200) {
      setSessionUser((prev) => ({ ...prev, profileImage: res?.data?.profileImage }));
      enqueueSnackbar(res.message, { variant: 'success', autoHideDuration: 3000 });
    } else {
      enqueueSnackbar(res.message, { variant: 'error', autoHideDuration: 3000 });
    }
    setLoading(false);
  };

  return (
    <>
      <Paper sx={{ px: { xs: 3, lg: 5 }, py: 3 }}>
        <PageBreadcrumb
          items={
            account
              ? []
              : profile
                ? [
                    {
                      label: 'Users',
                      url: '/users',
                    },
                    {
                      label: 'User Info',
                      url: '#!',
                      active: true,
                    },
                  ]
                : [
                    {
                      label: 'Candidate',
                      url: '/candidate',
                    },
                    {
                      label: 'Candidate Details',
                      url: '#!',
                      active: true,
                    },
                  ]
          }
          sx={{ mb: 2 }}
        />

        <Stack
          sx={{
            justifyContent: 'space-between',
            flexDirection: { xs: 'column', sm: 'row' },
            rowGap: 3,
            columnGap: 2,
          }}
        >
          <Stack
            sx={{
              flexDirection: { sm: 'column' },
              justifyContent: 'space-between',
              alignItems: { xs: 'center', sm: 'flex-start' },
              gap: 1,
              flexWrap: 'wrap',
            }}
          >
            <Stack gap={2} sx={{ alignItems: 'center' }}>
              {account ? (
                team ? (
                  <Avatar
                    alt={`${candidate.firstName.toUpperCase()} ${candidate.lastName}`}
                    src={`${url}${candidate.profileImage}`}
                    sx={{ width: 80, height: 80, borderRadius: '50%' }}
                  />
                ) : (
                  <ProfileAvatar
                    candidate={candidate}
                    url={url}
                    loading={loading}
                    onSelectFile={(file) => {
                      UploadFiles(file);
                    }}
                  />
                )
              ) : (
                <Avatar
                  alt={`${candidate.firstName.toUpperCase()} ${candidate.lastName}`}
                  src={`${url}${candidate.profileImage}`}
                  sx={{ width: 80, height: 80, borderRadius: '50%' }}
                />
              )}
              <div>
                <Typography variant="h5" sx={{ typography: { xs: 'h6', md: 'h5' } }}>
                  {`${candidate.firstName} ${candidate.lastName}`}
                </Typography>
                {profile && <Typography variant="body2">{`${candidate.role}`}</Typography>}
                <Typography variant="body2" color="textSecondary">
                  {`${candidate?.reportingManager ? 'Joined' : 'Applied'} On`}{' '}
                  <Box component="span" sx={{ color: 'text.primary', fontWeight: 600 }}>
                    {candidate?.reportingManager
                      ? moment(candidate.dateOfJoining).format('DD/MM/YYYY HH:mm A')
                      : moment(candidate.createdAt).format('DD/MM/YYYY HH:mm A')}
                  </Box>
                </Typography>
              </div>
            </Stack>
          </Stack>

          <Stack
            sx={{
              gap: { xs: 2, sm: 4 },
              flexDirection: 'row',
              justifyContent: 'space-between',
              alignItems: { sm: 'flex-end' },
            }}
          >
            {candidate?.reportingManager ? (
              <>
                <div>
                  <Typography variant="body1">Reporting Manager</Typography>
                  <Typography
                    variant="h5"
                    sx={{ typography: { xs: 'h6', md: 'h5' } }}
                  >{`${candidate?.reportingManager.firstName} ${candidate?.reportingManager.lastName}`}</Typography>
                  <Typography variant="body2" color="textSecondary">
                    <Box component="span" sx={{ color: 'text.primary', fontWeight: 600 }}>
                      {candidate.reportingManager.role}
                    </Box>
                  </Typography>
                </div>
                <div>
                  <Typography variant="body1">Module Access</Typography>
                  {candidate.moduleAccess.map((m) => (
                    <Typography key={m._id} variant="body2" color="textSecondary">
                      <Box component="span" sx={{ color: 'text.primary', fontWeight: 600 }}>
                        {m.name}
                      </Box>
                    </Typography>
                  ))}
                </div>
              </>
            ) : (
              <Stack gap={1} alignItems="center">
                {/* <StyledSelect
              variant="filled"
              defaultValue="Member"
              MenuProps={{
                slotProps: {
                  list: {
                    dense: true,
                  },
                },
              }}
              sx={{
                minWidth: { xs: 200, sm: 140, md: 180 },
                [`& .${selectClasses.icon}`]: { right: 8 },
              }}
            >
              <MenuItem value="Member">Member</MenuItem>
              <MenuItem value="Admin">Admin</MenuItem>
              <MenuItem value="Guest">Guest</MenuItem>
            </StyledSelect> */}

                <Button variant="soft" color="neutral" onClick={handleClick}>
                  {candidate.disqualified ? 'Qualified' : 'Disqualified'}
                </Button>
                <Button
                  variant="soft"
                  color="neutral"
                  disabled={candidate.disqualified}
                  onClick={handleOnBoard}
                >
                  {candidate.isUser ? '' : 'On Board'}
                </Button>
              </Stack>
            )}
            {/* <Box sx={{ textAlign: { sm: 'right' } }}>
              <Typography variant="subtitle1" color="textSecondary" mb={1}>
                Job Opeing{' '}
                <Box component="strong" whiteSpace="nowrap">
                  February 24, 2024
                </Box>{' '}
                for{' '}
                <Box component="strong" whiteSpace="nowrap">
                  Sr. Desinger
                </Box>
              </Typography>

              <Typography variant="subtitle1" color="textSecondary">
                <strong>100 Candidates</strong> Applied
              </Typography>
            </Box> */}
          </Stack>
        </Stack>
      </Paper>
      <Dialog
        open={open}
        onClose={onClose}
        aria-labelledby="dialog-title"
        component="form"
        onSubmit={handleSubmit(onSubmit)}
        sx={{
          [`& .${dialogClasses.paper}`]: {
            p: 0,
            borderRadius: 6,
            width: 1,
            maxWidth: 600,
          },
        }}
      >
        <Stack sx={{ p: 3, pb: 2, justifyContent: 'space-between', position: 'sticky', top: 0 }}>
          <DialogTitle id="dialog-title" sx={{ p: 0, typography: 'h6' }}>
            On Boarding Candidate
          </DialogTitle>
          <Button
            variant="text"
            size="small"
            color="neutral"
            onClick={onClose}
            sx={{ minWidth: 0, p: 0.5 }}
          >
            <IconifyIcon icon="material-symbols:close-rounded" sx={{ fontSize: 20 }} />
          </Button>
        </Stack>

        <DialogContent sx={{ px: 3, py: 1 }}>
          <Grid container spacing={2}>
            {/* Mode of Payment */}
            <Grid item size={{ xs: 12, sm: 12 }}>
              <Controller
                name="role"
                control={control}
                render={({ field }) => (
                  <TextField
                    {...field}
                    label="Designation"
                    fullWidth
                    error={!!errors.role}
                    helperText={errors.role?.message}
                    slotProps={{ htmlInput: { maxLength: 30 } }}
                  />
                )}
              />
            </Grid>
            <Grid item size={{ xs: 12, sm: 12 }}>
              <Controller
                name="reportingManager"
                control={control}
                render={({ field }) => (
                  <FormControl fullWidth error={!!errors.reportingManager}>
                    <InputLabel>Reporting Manager</InputLabel>
                    <Select {...field} label="Reporting Manager">
                      {users.map((u) => (
                        <MenuItem key={u._id} value={u._id}>
                          {`${u.firstName} ${u.lastName}`}
                        </MenuItem>
                      ))}
                    </Select>
                    <FormHelperText>{errors.reportingManager?.message}</FormHelperText>
                  </FormControl>
                )}
              />
            </Grid>
            <Grid item size={{ xs: 12, sm: 12 }}>
              <Controller
                name="jobCity"
                control={control}
                render={({ field }) => (
                  <FormControl fullWidth error={!!errors.jobCity}>
                    <InputLabel> City</InputLabel>
                    <Select {...field} label="Job City">
                      {city.map((c) => (
                        <MenuItem key={c._id} value={c._id}>
                          {`${c.name}`}
                        </MenuItem>
                      ))}
                    </Select>
                    <FormHelperText>{errors.reportingManager?.message}</FormHelperText>
                  </FormControl>
                )}
              />
            </Grid>
            <Grid item size={{ xs: 12, sm: 12 }}>
              <Controller
                name="modules"
                control={control}
                render={({ field }) => (
                  <FormControl fullWidth error={!!errors.modules}>
                    <InputLabel>Assign Modules</InputLabel>
                    <Select {...field} label="Assign Modulesr" multiple>
                      {modules.map((m) => (
                        <MenuItem key={m._id} value={m._id}>
                          {`${m.name}`}
                        </MenuItem>
                      ))}
                    </Select>
                    <FormHelperText>{errors.modules?.message}</FormHelperText>
                  </FormControl>
                )}
              />
            </Grid>
            <Grid item size={{ xs: 12, sm: 12 }}>
              <Controller
                name="dateOfJoining"
                control={control}
                render={({ field }) => (
                  <TextField
                    {...field}
                    label="Date Of Joining"
                    type="date"
                    variant="filled"
                    fullWidth
                    error={!!errors.dateOfJoining}
                    helperText={errors.dateOfJoining?.message}
                    slotProps={{
                      inputLabel: {
                        shrink: true,
                      },
                      htmlInput: {
                        max: moment().format('YYYY-MM-DD'), // 👉 disables future dates in calendar
                        onInvalid: (e) => e.preventDefault(), // ❗ blocks browser tooltip
                      },
                    }}
                  />
                )}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions sx={{ p: 3, pt: 2 }}>
          <Button variant="soft" color="neutral" onClick={() => reset()}>
            Reset
          </Button>
          <Button type="submit" variant="contained" autoFocus loading={submitLoading}>
            Submit
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={openConfirm} onClose={handleCancel}>
        <DialogTitle>Confirm</DialogTitle>
        <DialogContent>Are you sure you want to continue?</DialogContent>
        <DialogActions>
          <Button onClick={handleCancel}>No</Button>
          <Button color="error" onClick={handleConfirm}>
            Yes
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ProfileHeader;
